import { fork, all } from 'redux-saga/effects'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actionWorkflows from '../../actionWorkflows'
import addBuyClick from '../../../dataservices/addBuyClick'
import { processSaga, chainSagas, watchSaga } from '../workflow'
import { getParamsForBuyClickAdd, handleBuyClickRedirect } from './sagas'

const buyClickAddWorkflow = processSaga.bind(null, actionWorkflows.buyClickAdd, addBuyClick)
const buyClickChain = chainSagas.bind(null, [buyClickAddWorkflow, handleBuyClickRedirect])

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, actionTypes.buyButtonClick, buyClickChain, { latest: true, selectParams: getParamsForBuyClickAdd }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/buy/index.js